import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Accordion, RowToggleDataTable, Modal } from "react-bootstrap";
import AddBuildingModal from "./AddBuildingModal";
import "./_hostelAttendance.scss"
import SelectDropDown from '../selectdropdown/SelectDropDown';
import { components } from 'react-select';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import MultiSelect from "react-multi-select-component";
import S from "./buildingFinanceStyles";
import { BuildingListShimmer } from "./buildingShimmer";
import { attachModuleGuard, AccessDeniedModal } from "../../../utils/moduleGuard";
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";

// /building-creation → "Hostel_Buildings". Match on module_key only.
// This section opens AddBuildingModal (student→room allotment). No delete surface here.
const HOSTEL_BUILDINGS_MODULE = ["Hostel_Buildings"];

class HostelRoomAttendanceSection extends Component {
  constructor(props) {
    super();
    // this.handleBranchSubmit=this.handleBranchSubmit.bind(this);
    this.state = {
      branchSearch: "",
      branchError: "",

      addBuildingModal: false,

      activeBuildingDetails: null,
      activeFloorDetails: null,
      activeRoomDetails: null,
      activeCapacityDetails: null,
      getBuildingData: [],
      getFloorData: [],
      getRoomData: [],
      getStudentData: [],
      loading: 0,
      noDateError: "",
      isEdit: false,
      buildingFilter: "",
      viewStudentsModal: false,
      viewStudentsRoom: null,
      allStudents: [],
      accessDeniedShow: false,
    }

    this.guard = attachModuleGuard(this, HOSTEL_BUILDINGS_MODULE);
  }

  componentDidMount() {
    this.loadForBranchScope();
    // Branch comes from the header (NavbarOne) — reload when it changes.
    this.offBranchScope = onBranchScopeChange(() => this.loadForBranchScope());
  }

  componentDidUpdate(prevProps) {
    // globalBranches arrives async — load once it lands.
    if (prevProps.globals?.globalBranches !== this.props.globals?.globalBranches) {
      this.loadForBranchScope();
    }
  }

  componentWillUnmount() {
    if (this.offBranchScope) this.offBranchScope();
  }

  // The branches this page covers: the header's selection, narrowed to what the user
  // is authorized for. There is no branch picker here any more.
  scopedBranchIds = () =>
    scopeBranches(this.props.globals?.globalBranches || []).map((b) => parseInt(b.id));

  loadForBranchScope = () => {
    const ids = this.scopedBranchIds();
    if (ids.length === 0) {
      this.setState({ getBuildingData: [], allStudents: [], loading: 0 });
      return;
    }
    this.setState({
      branchError: "",
      getBuildingData: [],
      noDateError: "",
      buildingFilter: "",
      activeBuildingDetails: null,
      activeFloorDetails: null,
      activeRoomDetails: null,
      getFloorData: [],
      getRoomData: [],
      getStudentData: [],
      loading: 1,
    }, () => {
      this.getBuildingCreationDetails();
      this.fetchBranchStudents();
    });
  };

  // The two inline entry points into AddBuildingModal (new allocation + edit from the
  // room card). Gating the openers stops the allotment write; the buttons stay visible
  // and clickable. AddBuildingModal re-checks at its own submit.
  openNewAllocation = () => {
    if (!this.guard.requireEdit()) return;
    this.setState({ addBuildingModal: true });
  };

  openEditAllocation = () => {
    if (!this.guard.requireEdit()) return;
    this.setState({ addBuildingModal: true, isEdit: true });
  };

  // Branch students straight from edu_students (so allocated students without a
  // class/section — missing from getNewEducationalStudents — still resolve).
  // getAllotmentStudents takes a single branch_id, so fan it out across the header's
  // branch scope and concatenate.
  fetchBranchStudents = async () => {
    try {
      const results = await Promise.all(this.scopedBranchIds().map((branch_id) => this.props.client.query({
        query: gql`
          query($institute_id: Int, $branch_id: Int){
            getAllotmentStudents(institute_id: $institute_id, branch_id: $branch_id){
              student_id
              student_name
              roll_no
            }
          }
        `,
        variables: { institute_id: parseInt(Cookies.get("institutionid")), branch_id: branch_id },
        fetchPolicy: 'network-only',
      })));
      this.setState({ allStudents: results.flatMap((r) => (r.data && r.data.getAllotmentStudents) || []) });
    } catch (e) {
      console.error("Error fetching branch students:", e);
      this.setState({ allStudents: [] });
    }
  };

  // Resolve a student record across both sources (edu_students first).
  findStudent = (id) =>
    this.state.allStudents.find((x) => x.student_id == id)
    || (this.props.getNewEducationalStudents || []).find((x) => x.student_id == id);

  // ── Stat helpers (unique students = filled) ──
  roomFilled = (room) => {
    if (!room.capacity_details || room.capacity_details.length === 0) return 0;
    return room.capacity_details.filter(
      (it, i, arr) => arr.findIndex((o) => o.edu_student_id == it.edu_student_id) === i
    ).length;
  };
  buildingRooms = (b) =>
    b.floors_details.reduce((t, f) => t + (f.rooms_details ? f.rooms_details.length : 0), 0);
  buildingCapacity = (b) =>
    b.floors_details.reduce((t, f) => t + (f.rooms_details ? f.rooms_details.reduce((rt, r) => rt + (r.room_capacity || 0), 0) : 0), 0);
  buildingFilledCount = (b) =>
    b.floors_details.reduce((t, f) => t + (f.rooms_details ? f.rooms_details.reduce((rt, r) => rt + this.roomFilled(r), 0) : 0), 0);
  floorCapacity = (f) => f.rooms_details.reduce((t, r) => t + (r.room_capacity || 0), 0);
  floorFilled = (f) => f.rooms_details.reduce((t, r) => t + this.roomFilled(r), 0);

  // Select a building in the master list → show only its floors in the detail pane.
  selectBuildingMD = (item) => {
    this.setState({
      activeBuildingDetails: item.hostel_building_id,
      activeFloorDetails: null,
      activeRoomDetails: null,
      getFloorData: item.floors_details,
      getRoomData: [],
      getStudentData: [],
    });
  };

  // Expand / collapse a floor in the detail pane (display only).
  toggleFloorMD = (floorId) => {
    this.setState((prev) => ({
      activeFloorDetails: prev.activeFloorDetails === floorId ? null : floorId,
      activeRoomDetails: null,
      getStudentData: [],
    }));
  };

  // Open the allocation modal in edit mode for a room. Sets every piece of
  // state the modal's prefill reads, sourced from the CURRENT (fresh) building
  // data so an edit right after an in-place refresh still shows correct values.
  // Room "edit" — loads the room's allotment into AddBuildingModal. Gated before the
  // modal opens, so a role without is_edit never sees a form it can't save.
  editRoom = (building, floor, room) => {
    if (!this.guard.requireEdit()) return;

    const uniq = (room.capacity_details || []).filter(
      (it, i, arr) => arr.findIndex((o) => o.edu_student_id == it.edu_student_id) === i
    );
    this.setState({
      activeBuildingDetails: building.hostel_building_id,
      activeFloorDetails: floor.floor_id,
      activeRoomDetails: room.room_id,
      activeCapacityDetails: room.room_capacity,
      getFloorData: building.floors_details,
      getRoomData: floor.rooms_details,
      getStudentData: uniq,
      addBuildingModal: true,
      isEdit: true,
    });
  };

  // Small coloured stat chip used across the master-detail view.
  statChip = (label, val, kind) => {
    const c = kind === "green" ? { bg: "#dcfce7", c: "#15803d", b: "#bbf7d0" }
      : kind === "amber" ? { bg: "#fef9c3", c: "#a16207", b: "#fde68a" }
        : { bg: "#eef2ff", c: "#4338ca", b: "#e0e7ff" };
    return (
      <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 12, fontWeight: 600, background: c.bg, color: c.c, border: `1px solid ${c.b}`, borderRadius: 8, padding: "3px 10px" }}>
        {label} : {val}
      </span>
    );
  };

  renderAllocationMaster = () => {
    const q = this.state.buildingFilter.trim().toLowerCase();
    const sorted = [...this.state.getBuildingData].sort((a, b) => b.hostel_building_id - a.hostel_building_id);
    const filtered = q ? sorted.filter((b) => (b.hostel_building_name || "").toLowerCase().includes(q)) : sorted;
    const activeBuilding = this.state.getBuildingData.find((b) => b.hostel_building_id === this.state.activeBuildingDetails);

    return (
      <div style={S.mdWrap}>
        {/* ── Master list: searchable buildings ── */}
        <div style={S.listPane}>
          <div style={S.searchBox}>
            <i className="fal fa-search" style={S.searchIcon} />
            <input type="text" placeholder="Search building…" value={this.state.buildingFilter} onChange={(e) => this.setState({ buildingFilter: e.target.value })} style={S.searchInput} />
          </div>
          <div style={S.listScroll}>
            {filtered.length > 0 ? filtered.map((b) => {
              const isActive = this.state.activeBuildingDetails === b.hostel_building_id;
              const cap = this.buildingCapacity(b);
              const filled = this.buildingFilledCount(b);
              return (
                <div key={b.hostel_building_id} onClick={() => this.selectBuildingMD(b)} style={isActive ? S.buildingItemActive : S.buildingItem}>
                  <div style={S.buildingItemName}>
                    <i className="fal fa-building" style={{ color: "#4f46e5" }} />
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{b.hostel_building_name}</span>
                  </div>
                  <div style={S.miniChipRow}>
                    <span style={S.miniChip}>Floors {b.floors_details.length}</span>
                    <span style={S.miniChip}>Cap {cap}</span>
                    <span style={{ ...S.miniChip, background: "#dcfce7", color: "#15803d", borderColor: "#bbf7d0" }}>Filled {filled}</span>
                    <span style={{ ...S.miniChip, background: "#fef9c3", color: "#a16207", borderColor: "#fde68a" }}>Vac {cap - filled}</span>
                  </div>
                </div>
              );
            }) : (
              <div style={{ ...S.noData, padding: "32px 0" }}>
                <i className="fal fa-search" style={{ fontSize: 26, marginBottom: 8 }} />
                <span style={{ fontSize: 13 }}>No building matches “{this.state.buildingFilter}”</span>
              </div>
            )}
          </div>
        </div>

        {/* ── Detail pane: floors → rooms → allocated students ── */}
        <div style={S.detailPane}>
          {activeBuilding ? (() => {
            const cap = this.buildingCapacity(activeBuilding);
            const filled = this.buildingFilledCount(activeBuilding);
            return (
              <>
                <div style={S.detailHeader}>
                  <h5 style={S.detailTitle}><i className="fal fa-building" style={{ color: "#4f46e5" }} />{activeBuilding.hostel_building_name}</h5>
                  {this.statChip("Floors", activeBuilding.floors_details.length)}
                  {this.statChip("Rooms", this.buildingRooms(activeBuilding))}
                  {this.statChip("Capacity", cap)}
                  {this.statChip("Filled", filled, "green")}
                  {this.statChip("Vacancies", cap - filled, "amber")}
                </div>

                {activeBuilding.floors_details.length > 0 ? activeBuilding.floors_details.map((floor) => {
                  const isOpen = this.state.activeFloorDetails === floor.floor_id;
                  const fcap = this.floorCapacity(floor);
                  const ffilled = this.floorFilled(floor);
                  return (
                    <div key={floor.floor_id} style={S.floorBlock}>
                      <div style={S.floorHead} onClick={() => this.toggleFloorMD(floor.floor_id)}>
                        <i className={`fa-fw far ${isOpen ? "fa-minus-square" : "fa-plus-square"}`} style={{ color: "#6366f1" }} />
                        <span style={S.floorName}><i className="fal fa-layer-group" />{floor.floor_name}</span>
                        <span style={{ marginLeft: "auto", display: "inline-flex", gap: 6, flexWrap: "wrap" }}>
                          {this.statChip("Rooms", floor.rooms_details.length)}
                          {this.statChip("Cap", fcap)}
                          {this.statChip("Filled", ffilled, "green")}
                          {this.statChip("Vac", fcap - ffilled, "amber")}
                        </span>
                      </div>
                      {isOpen && (
                        <div style={{ padding: 14 }}>
                          {floor.rooms_details.map((room) => {
                            const rfilled = this.roomFilled(room);
                            return (
                              <div key={room.room_id} style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: "12px 14px", marginBottom: 10, background: "#fff" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                                  <span style={{ fontWeight: 700, color: "#0f172a", display: "flex", alignItems: "center", gap: 6 }}><i className="fal fa-door-open" style={{ color: "#7c3aed" }} />{room.room_name}</span>
                                  {this.statChip("Capacity", room.room_capacity)}
                                  {this.statChip("Filled", rfilled, "green")}
                                  {this.statChip("Vacancy", room.room_capacity - rfilled, "amber")}
                                  <Button variant="link" name="view" title="View allocated students" className="p-0" style={{ marginLeft: "auto" }}
                                    onClick={() => this.setState({ viewStudentsModal: true, viewStudentsRoom: room })}>
                                    <i className="fal fa-eye" style={{ color: "#7c3aed" }} />
                                  </Button>
                                  <Button variant="link" name="edit" title="Edit allocation" className="p-0" onClick={() => this.editRoom(activeBuilding, floor, room)}>
                                    <i className="far fa-edit" style={{ color: "#4f46e5" }} />
                                  </Button>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                }) : (
                  <div style={{ padding: "20px 0", textAlign: "center", color: "#94a3b8", fontSize: 13 }}>No floors configured.</div>
                )}
              </>
            );
          })() : (
            <div style={S.detailPlaceholder}>
              <i className="fal fa-hand-pointer" style={{ fontSize: 34, marginBottom: 12 }} />
              <h6 style={{ color: "#64748b", margin: 0 }}>Select a building</h6>
              <span style={{ fontSize: 13, marginTop: 4 }}>Pick a building from the left to view its floors, rooms and allocated students.</span>
            </div>
          )}
        </div>
      </div>
    );
  };
  // getBuildingCreationDetails takes a single branch_id, so fan it out across the
  // header's branch scope and concatenate — each building belongs to one branch.
  getBuildingCreationDetails = async () => {
    const results = await Promise.all(this.scopedBranchIds().map((branch_id) => this.props.client.query({
      query: gql`
                query($institute_id: Int!, $branch_id: Int!){
                    getBuildingCreationDetails(institute_id: $institute_id, branch_id:$branch_id) {
                        hostel_building_id
                        hostel_building_name
                        floors_details{
                          floor_id
                          floor_name
                          rooms_details{
                            room_id
                            room_name
                            room_capacity
                            capacity_details{
                              edu_student_id
                            }
                          }
                        }
                    }
                }
                `,
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
        branch_id: branch_id
      },
      fetchPolicy: 'network-only'
    })))
    const buildings = results.flatMap((r) => (r.data && r.data.getBuildingCreationDetails) || [])
    if (buildings.length > 0) {
      let filter_data = buildings
      // Default-select a building so the detail pane isn't empty: keep the one
      // the user was viewing if it still exists, otherwise the latest (highest id).
      const stillSelected = filter_data.find(
        (b) => b.hostel_building_id === this.state.activeBuildingDetails);
      const defaultBuilding = stillSelected || [...filter_data].sort(
        (a, b) => b.hostel_building_id - a.hostel_building_id)[0];
      this.setState({
        getBuildingData: filter_data,
        loading: 0,
        activeBuildingDetails: defaultBuilding.hostel_building_id,
        getFloorData: defaultBuilding.floors_details,
      })

    } else {
      this.setState({ loading: 0, getBuildingData: [], noDateError: "No Data Available" })

    }
  }

  handleAccordionClick1 = (item, name, isEdit) => {

    console.log("item", item);

    if (name == "building") {
      if (this.state.activeBuildingDetails == item.hostel_building_id) {
        this.setState({ activeBuildingDetails: null, activeFloorDetails: null, activeRoomDetails: null, activeCapacityDetails: null, getFloorData: [], getRoomData: [], getStudentData: [] });
      } else if (this.state.activeBuildingDetails != null && this.state.activeBuildingDetails != item.hostel_building_id) {
        const floorData = this.state.getBuildingData.filter((a) => a.hostel_building_id === item.hostel_building_id)[0].floors_details;
        this.setState({ activeBuildingDetails: item.hostel_building_id, activeFloorDetails: null, activeRoomDetails: null, activeCapacityDetails: null, getFloorData: floorData, getRoomData: [], getStudentData: [] });
      } else {
        const floorData = this.state.getBuildingData.filter((a) => a.hostel_building_id === item.hostel_building_id)[0].floors_details;
        this.setState({ activeBuildingDetails: item.hostel_building_id, getFloorData: floorData });
      }
    }


    if (name == "floor") {

      if (this.state.activeFloorDetails === item) {
        this.setState({ activeFloorDetails: null, activeRoomDetails: null, activeCapacityDetails: null, getRoomData: [], getStudentData: [] });
      } else {

        const roomData = this.state.getFloorData.filter((a) => a.floor_id === item)[0].rooms_details;
        this.setState({ activeFloorDetails: item, getRoomData: roomData });
      }
    }

    if (name == "room") {


      console.log("state", this.state.isEdit);
      if (this.state.activeRoomDetails === item.room_id && !isEdit) {
        this.setState({ activeRoomDetails: null, activeCapacityDetails: null, getStudentData: [] });
      } else {
        const studentData = this.state.getRoomData.filter((a) => a.room_id === item.room_id)[0].capacity_details;
        let capacityDetails = [];

        if (studentData.length > 0) {
          capacityDetails = studentData.filter((item, index, array) => {
            return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
          })
        }
        this.setState({ activeRoomDetails: item.room_id, getStudentData: capacityDetails, activeCapacityDetails: item.room_capacity });
      }
    }

  };

  handleBranchSubmit = (e) => {
    e.preventDefault();
    this.loadForBranchScope();
  }





  //   componentDidMount(){
  //     let e = {
  //         preventDefault: function () {

  //         }
  //     }

  //     setTimeout(() => {
  //         this.handleBranchSubmit(e)

  //     }, 100)
  // }



  render() {
    console.log("oooo121o", this.state);

    if (this.props.studentCreationModal) {
      this.state.addBuildingModal = true
    }
    return (
      <div style={S.page}>
        {/* ── Student Allocation Card ── */}
        <div style={S.card}>
          <div style={S.cardHeader}>
            <div style={S.iconWrapperList}>
              <i className="fal fa-users" />
            </div>
            <div style={S.cardTitleText}>
              <h5 style={S.cardTitle}>Student Allocation</h5>
              <span style={S.cardSubtitle}>Allocate students to hostel rooms and track occupancy</span>
            </div>
            <button
              style={S.addBtn}
              onClick={this.openNewAllocation}
            >
              <i className="fal fa-plus" /> New Allocation
            </button>
          </div>

          <div style={S.cardBody}>
            {/* No Branch picker — the header (NavbarOne) scopes this page. */}

            {
              this.state.getBuildingData.length > 0 ? (
                this.renderAllocationMaster()
              ) : (
                <div className="mt-3">
                  {this.state.loading == 1 ? (
                    <BuildingListShimmer rows={3} />
                  ) : this.state.noDateError != "" ? (
                    <div style={S.noData}>
                      <i className="fal fa-users" style={{ fontSize: 40, marginBottom: 12 }} />
                      <h6 style={{ color: "#64748b", margin: 0 }}>{this.state.noDateError}</h6>
                      <span style={{ fontSize: 13, marginTop: 4 }}>Select a branch and submit to view allocations</span>
                    </div>
                  ) : ("")}
                </div>
              )}
            {false && (
                <div className="hostel-accordion mt-4">
                  <Accordion >
                    {[...this.state.getBuildingData]
                      .sort((a, b) => b.hostel_building_id - a.hostel_building_id)
                      .map((item, index) => {

                      console.log("itemsss", item);
                      return (
                        <Card >
                          <Accordion.Toggle
                            className="building_bg student_building_bg"
                            as={Card.Header}
                            eventKey={index.toString()}
                            onClick={() => this.handleAccordionClick1(item, "building")}
                          >

                            <Row>
                              <Col xl={1} lg={1} md={1} sm={2} xs={2}>
                                {this.state.activeBuildingDetails === item.hostel_building_id ?
                                  <i className="fa-fw far fa-minus-square" style={{ cursor: "pointer" }}></i>
                                  :
                                  <i className="fa-fw far fa-plus-square" style={{ cursor: "pointer" }}></i>
                                }
                              </Col>
                              <Col lg={2} md={1} sm={2}>
                                <div><i className="fal fa-building mr-2" />{item.hostel_building_name}</div></Col>
                              <Col lg={2} md={1} sm={2}> <div className="stat-pill">Floors : {item.floors_details.length}</div></Col>
                              <Col lg={2} md={1} sm={2}>
                                <div className="stat-pill">Rooms : {
                                  item.floors_details.reduce((totalRooms, floor) => {
                                    return totalRooms + (floor.rooms_details ? floor.rooms_details.length : 0);
                                  }, 0)
                                }</div>
                              </Col>
                              <Col lg={2} md={1} sm={2}>
                                <div className="stat-pill">Capacity : {
                                  item.floors_details.reduce((totalCapacity, floor) => {
                                    return totalCapacity + (floor.rooms_details ? floor.rooms_details.reduce((roomCapacity, room) => {
                                      return roomCapacity + (room.room_capacity ? room.room_capacity : 0);
                                    }, 0) : 0);
                                  }, 0)
                                }</div>
                              </Col>
                              <Col lg={1} md={1} sm={2}>
                                <div className="stat-pill stat-pill-green">Filled : {
                                  item.floors_details.reduce((totalStudents, floor) => {
                                    return totalStudents + (floor.rooms_details ? floor.rooms_details.reduce((roomStudents, room) => {
                                      let capacityDetails = [];

                                      if (room.capacity_details.length > 0) {
                                        capacityDetails = room.capacity_details.filter((item, index, array) => {
                                          return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
                                        })
                                      }
                                      const filledStudents = capacityDetails.length;
                                      return roomStudents + filledStudents;
                                    }, 0) : 0);
                                  }, 0)
                                }</div>
                              </Col>
                              <Col lg={2} md={1} sm={2}>
                                <div className="stat-pill stat-pill-amber">Vacancies : {
                                  item.floors_details.reduce((totalCapacity, floor) => {
                                    return totalCapacity + (floor.rooms_details ? floor.rooms_details.reduce((roomCapacity, room) => {
                                      return roomCapacity + (room.room_capacity ? room.room_capacity : 0);
                                    }, 0) : 0);
                                  }, 0) -
                                  item.floors_details.reduce((totalStudents, floor) => {
                                    return totalStudents + (floor.rooms_details ? floor.rooms_details.reduce((roomStudents, room) => {
                                      let capacityDetails = [];

                                      if (room.capacity_details.length > 0) {
                                        capacityDetails = room.capacity_details.filter((item, index, array) => {
                                          return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
                                        })
                                      }
                                      const filledStudents = capacityDetails.length;
                                      return roomStudents + filledStudents;
                                    }, 0) : 0);
                                  }, 0)
                                }</div>
                              </Col>
                            </Row>
                          </Accordion.Toggle>

                          <Accordion.Collapse eventKey={index.toString()}>
                            <Card.Body className="building_bg student_building_bg">

                              {
                                item.hostel_building_id == this.state.activeBuildingDetails ? (
                                  item.floors_details.map((floor, floorIndex) => (

                                    <Accordion activeKey={this.state.activeFloorDetails}>
                                      <Card>
                                        <Accordion.Toggle
                                          className="floor_bg student_floor_bg"
                                          as={Card.Header}
                                          eventKey={floor.floor_id}
                                          onClick={() => this.handleAccordionClick1(floor.floor_id, "floor")}
                                        >
                                          <Row>
                                            <Col xl={1} lg={1} md={1} sm={2} xs={2}>
                                              {this.state.activeFloorDetails === floor.floor_id ? (
                                                <i className="fa-fw far fa-minus-square" style={{ cursor: "pointer" }}></i>
                                              ) : (
                                                <i className="fa-fw far fa-plus-square" style={{ cursor: "pointer" }}></i>
                                              )}
                                            </Col>
                                            <Col xl={11} lg={11} md={11} sm={10} xs={10} className="d-flex justify-content-between">
                                              <div>{floor.floor_name}</div>
                                              <div className="stat-pill">Rooms : {floor.rooms_details.length}</div>
                                              <div className="stat-pill">Room Capacity : {
                                                floor.rooms_details.reduce((totalCapacity, room) => {
                                                  return totalCapacity + (room.room_capacity ? room.room_capacity : 0);
                                                }, 0)
                                              }</div>
                                              <div className="stat-pill stat-pill-green">Filled : {
                                                floor.rooms_details.reduce((totalfilled, room) => {
                                                  let capacityDetails = [];

                                                  if (room.capacity_details.length > 0) {
                                                    capacityDetails = room.capacity_details.filter((item, index, array) => {
                                                      return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
                                                    })
                                                  } const filledStudents = capacityDetails.length
                                                  return totalfilled + filledStudents
                                                }, 0)
                                              }</div>
                                              <div className="stat-pill stat-pill-amber">Vacancies : {
                                                floor.rooms_details.reduce((totalCapacity, room) => {
                                                  return totalCapacity + (room.room_capacity ? room.room_capacity : 0);
                                                }, 0) -
                                                floor.rooms_details.reduce((totalfilled, room) => {
                                                  let capacityDetails = [];

                                                  if (room.capacity_details.length > 0) {
                                                    capacityDetails = room.capacity_details.filter((item, index, array) => {
                                                      return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
                                                    })
                                                  } const filledStudents = capacityDetails.length
                                                  return totalfilled + filledStudents
                                                }, 0)
                                              }</div>
                                            </Col>
                                          </Row>
                                        </Accordion.Toggle>
                                        {
                                          this.state.activeFloorDetails == floor.floor_id ? (
                                            <Accordion.Collapse eventKey={floor.floor_id}>
                                              <Card.Body className="floor_bg student_floor_bg">
                                                {floor.rooms_details.map((room, roomIndex) => {
                                                  let popupshow = false;
                                                  let uniqCapacityDetails = room.capacity_details.filter((item, index, array) => {
                                                    return array.findIndex((obj) => obj.edu_student_id == item.edu_student_id) === index
                                                  })
                                                  console.log("uniqCapacityDetails", uniqCapacityDetails);
                                                  return (
                                                    <Accordion activeKey={this.state.activeRoomDetails}>
                                                      <Card>
                                                        <Accordion.Toggle
                                                          className="room_bg student_room_bg"
                                                          as={Card.Header}
                                                          eventKey={room.room_id}
                                                          onClick={() => this.handleAccordionClick1(room, "room", popupshow)}
                                                        >
                                                          <Row>
                                                            <Col xl={1} lg={1} md={1} sm={2} xs={2}>
                                                              {this.state.activeRoomDetails === room.room_id ? (
                                                                <i className="fa-fw far fa-minus-square" style={{ cursor: "pointer" }}></i>
                                                              ) : (
                                                                <i className="fa-fw far fa-plus-square" style={{ cursor: "pointer" }}></i>
                                                              )}
                                                            </Col>
                                                            <Col xl={11} lg={11} md={11} sm={10} xs={10} className="d-flex justify-content-between">
                                                              <div><i className="fal fa-door-open mr-2" />{room.room_name}</div>
                                                              <div className="stat-pill">Room Capacity : {room.room_capacity}</div>
                                                              <div className="stat-pill stat-pill-green">Filled : {uniqCapacityDetails ? uniqCapacityDetails.length : 0}</div>
                                                              <div className="stat-pill stat-pill-amber">Vacancies : {
                                                                (room.room_capacity) - (uniqCapacityDetails ? uniqCapacityDetails.length : 0)
                                                              }</div>


                                                              <div onClick={() => {
                                                                this.openEditAllocation();
                                                                popupshow = true;
                                                              }}>
                                                                <Button variant="link" name="edit" className="text-dark mb-2">
                                                                  <i className="far fa-edit" style={{ color: "#4f46e5" }} />
                                                                </Button>
                                                              </div>

                                                            </Col>
                                                          </Row>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey={room.room_id} >
                                                          <Card.Body className="student_bg" >
                                                            <Card className="student_bg text-dark" style={{ border: "none" }}>
                                                              <Row>
                                                                {uniqCapacityDetails.length > 0 ? (
                                                                  uniqCapacityDetails.map((capacity) => {

                                                                    let studentData = this.props.getNewEducationalStudents.find((student) => student.student_id == capacity.edu_student_id)
                                                                    console.log("studentData", studentData.student_name, studentData);
                                                                    return (
                                                                      <Col lg={3} >
                                                                        <div className="student-chip mt-1">
                                                                          <i className="fal fa-user-graduate mr-2" />
                                                                          <span>
                                                                            {studentData.student_name} ({studentData.roll_no})
                                                                          </span>
                                                                        </div>
                                                                      </Col>
                                                                    )
                                                                  }


                                                                  )
                                                                ) : (
                                                                  <Col lg={12}>
                                                                    <div className="mt-1 text-center">Please allocate students</div>
                                                                  </Col>
                                                                )}
                                                              </Row>
                                                            </Card>

                                                          </Card.Body>
                                                        </Accordion.Collapse>

                                                      </Card>
                                                    </Accordion>
                                                  )
                                                }
                                                )}
                                              </Card.Body>
                                            </Accordion.Collapse>

                                          ) : ("")
                                        }

                                      </Card>
                                    </Accordion>
                                  ))
                                ) : ("")
                              }

                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      );
                    })}
                  </Accordion>
                </div>
            )}
          </div>
        </div>

        <AddBuildingModal
          globals={this.props.globals}
          getNewEducationalStudents={this.props.getNewEducationalStudents}
          stateData={this.state}
          show={this.state.addBuildingModal}
          onHide={() => this.setState({ addBuildingModal: false, isEdit: false, activeRoomDetails: null, })}
          onSaved={() => {
            // Refresh the allocation list in place (shimmer while loading).
            // Keep the building selected but collapse floors so nothing is
            // expanded until the user clicks it again.
            this.setState({
              loading: 1,
              getBuildingData: [],
              activeFloorDetails: null,
              activeRoomDetails: null,
              getFloorData: [],
              getRoomData: [],
              getStudentData: [],
              noDateError: "",
            }, () => this.getBuildingCreationDetails());
          }}
        />

        {/* ── View allocated students modal ── */}
        <Modal show={this.state.viewStudentsModal} onHide={() => this.setState({ viewStudentsModal: false, viewStudentsRoom: null })} className="bc-modal" size="lg" centered>
          <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)" }}>
            <Modal.Header style={{ background: "#fff", borderBottom: "1px solid #f1f5f9", padding: "16px 22px" }}>
              <Modal.Title style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", margin: 0 }}>
                <span style={S.iconWrapperList}><i className="fal fa-user-graduate" /></span>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span style={{ fontSize: 17, fontWeight: 700, color: "#0f172a", lineHeight: 1.2 }}>
                    Allocated Students{this.state.viewStudentsRoom ? ` — ${this.state.viewStudentsRoom.room_name}` : ""}
                  </span>
                  <span style={{ fontSize: 12, fontWeight: 500, color: "#64748b", marginTop: 2 }}>
                    {this.state.viewStudentsRoom ? `${this.roomFilled(this.state.viewStudentsRoom)} of ${this.state.viewStudentsRoom.room_capacity} beds filled` : ""}
                  </span>
                </div>
                <button type="button" aria-label="Close" onClick={() => this.setState({ viewStudentsModal: false, viewStudentsRoom: null })} style={S.modalClose}>&times;</button>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: 20, maxHeight: 290, overflowY: "auto" }}>
              {(() => {
                const room = this.state.viewStudentsRoom;
                if (!room) return null;
                const uniq = (room.capacity_details || []).filter((it, i, arr) => arr.findIndex((o) => o.edu_student_id == it.edu_student_id) === i);
                if (uniq.length === 0) {
                  return (
                    <div style={{ ...S.detailPlaceholder, minHeight: 140 }}>
                      <i className="fal fa-user-slash" style={{ fontSize: 30, marginBottom: 10 }} />
                      <span style={{ fontSize: 13 }}>No students allocated to this room yet.</span>
                    </div>
                  );
                }
                return (
                  <Row>
                    {uniq.map((capacity, idx) => {
                      const s = this.findStudent(capacity.edu_student_id);
                      return (
                        <Col lg={4} md={4} sm={6} className="mb-2" key={capacity.edu_student_id}>
                          <div style={{ display: "flex", alignItems: "center", gap: 10, background: "#f8fafc", border: "1px solid #eef2f7", borderRadius: 10, padding: "10px 12px" }}>
                            <span style={{ width: 28, height: 28, borderRadius: "50%", background: "#e0e7ff", color: "#4f46e5", fontSize: 12, fontWeight: 700, display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{idx + 1}</span>
                            <span style={{ display: "flex", flexDirection: "column" }}>
                              <span style={{ fontWeight: 600, fontSize: 13, color: "#0f172a" }}>{s ? s.student_name : `Student #${capacity.edu_student_id}`}</span>
                              {s && <span style={{ fontSize: 11, color: "#64748b" }}>Roll No: {s.roll_no}</span>}
                            </span>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                );
              })()}
            </Modal.Body>
          </div>
        </Modal>

        {/* Shown instead of opening the allotment modal when is_edit is missing. This
            section has no delete surface. */}
        <AccessDeniedModal
          show={this.state.accessDeniedShow}
          onHide={this.guard.hideAccessDenied}
        />
      </div>
    )
  }
}
export default withRouter(withApollo(
  (HostelRoomAttendanceSection))
);
